import * as React from "react";
import { Icon } from "../../icon/icon/icon.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
const ClearButton = React.forwardRef(function ClearButton2(props, ref) {
  const labels = useLabels();
  const { className, label, onClick, tabIndex } = props;
  const BEM = () => {
    const classArray = ["clear-btn"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("button", { className: BEM(), onClick, type: "button", ref, tabIndex }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#close", className: "clear-btn__icon" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, label != null ? label : labels.get("clear")));
});
export {
  ClearButton
};
